<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span class="title-box-text">
                    Причины отклонения регистрации
                </span>
                <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
                    color="var(--app-dark-blue-1)">mdi-information</v-icon>
            </div>
            <v-btn @click="openDialog" class=" button-accept">
                + Добавить причину
            </v-btn>
        </div>
        <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
            <v-card min-width="300px" min-height="100px">
                <div class="menu-container">
                    <div class="menu-container-title">
                        «Причины отклонения регистрации»
                    </div>
                    <div class="menu-container-text">
                        Причина будет отображаться в профиле мобильного приложения. Она должна отображать,
                        что необходимо изменить в профиле для прохождения модерации.
                    </div>

                </div>

            </v-card>
        </v-menu>


        <div class="container-table-box">
            <v-data-table :headers="tableHeaders" :items="items" item-key="id" :search="search"
                :footer-props="{ itemsPerPageOptions: [10, 25, 50], 'items-per-page-text': '' }"
                :items-per-page="optionTable.itemsPerPage" :server-items-length="optionTable.serverItemsLength"
                @pagination="tableChange" class="elevation-0 rounded-0 container-table">
                <template v-slot:item.actions="{ item }">
                    <v-icon @click="openDialog(item)">mdi-pencil-outline</v-icon>
                </template>

            </v-data-table>

        </div>

        <v-dialog width="570px" height="auto" persistent v-model="dialog">
            <v-card width="570px" height="auto" class="rounded-0">
                <v-form ref="formSecond">
                    <v-card-title class="dialog-title">
                        <span v-if="selectedItem.id" class="title">Редактировать причину</span>
                        <span v-else class="title">Добавить причину</span>
                        <v-icon @click="closeDialog">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text class="dialog-description">

                        <v-text-field class="mt-2" outlined v-model="selectedItem.text" label="Название"></v-text-field>

                    </v-card-text>
                    <v-card-actions class="dialog-buttons">
                        <v-btn style="width: 120px !important" @click="saveReason" class="button-accept">
                            Сохранить
                        </v-btn>
                        <v-btn v-if="selectedItem.id" @click="deleteReason" outlined style="width: 120px !important"
                            color="var(--app-red-1)" class="button-accept-outlined">
                            Удалить
                        </v-btn>
                    </v-card-actions>


                </v-form>
            </v-card>
        </v-dialog>


    </div>
</template>
<script>

export default {

    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        search: '',
        dialog: false,
        selectedItem: {},
        items: [

        ],
        tableHeaders: [
            { text: 'Навзание', sortable: false, value: 'text' },
            { text: '', sortable: false, align: 'right', value: 'actions' },

        ],
        optionTable: {
            page: 1,
            itemsPerPage: 10,
            serverItemsLength: -1
        },

    }),
    methods: {

        openDialog(item) {
            if (item) {
                this.selectedItem = Object.assign({}, item)
                this.dialog = true
            }
            else {
                this.dialog = true
            }

        },
        openInfo(e) {
            e.preventDefault()
            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },
        closeDialog() {
            this.selectedItem = {}
            this.dialog = false
        },
        getItems() {
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/club/moderation/refuse/reason/list', {
                optionTable: this.optionTable,
            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {
                    this.items = res.data.items
                    this.optionTable = res.data.optionTable

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },
        tableChange(data) {
            this.optionTable.page = data.page
            this.optionTable.itemsPerPage = data.itemsPerPage
            this.getItems()
        },
        saveReason() {
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/club/moderation/refuse/reason', {
                reasonId: this.selectedItem.id ? this.selectedItem.id : '',
                text: this.selectedItem.text,
            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(() => {
                    this.selectedItem = {}
                    this.dialog = false
                    this.getItems()

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },
        deleteReason() {
            this.$axios.delete(this.$store.getters.apiAdminPanelV2 + '/club/moderation/refuse/reason', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    reasonId: this.selectedItem.id
                }
            })
                .then(() => {
                    this.selectedItem = {}
                    this.dialog = false
                    this.getItems()
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },




    },
    mounted() {

    },
    created() {
        this.getItems()
    }
}
</script>
<style lang="scss" scoped>
.container-table-box {
    height: calc(100vh - 186px) !important;
    overflow: auto;

    .container-table {
        height: calc(100vh - 186px) !important;
        min-height: calc(100vh - 186px) !important;
        max-height: calc(100vh - 186px) !important;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

    }
}

.dialog-description-subtitle {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 24px;
}
</style>